import { z } from 'zod';
// ── Enums ─────────────────────────────────────────────────────────────────
export const FeedbackTypeSchema = z.enum([
    'bug',
    'feature_request',
    'general',
    'complaint',
]);
export const FeedbackAppSchema = z.enum(['web_dashboard', 'marketing']);
export const FeedbackStatusSchema = z.enum([
    'new',
    'reviewed',
    'in_progress',
    'resolved',
    'closed',
    'wont_fix',
]);
// ── Attachments ───────────────────────────────────────────────────────────
export const FeedbackAttachmentKindSchema = z.enum(['screenshot', 'attached']);
/** Server returns this after a successful upload. */
export const UploadedAttachmentSchema = z.object({
    id: z.string(),
    url: z.string(), // GET URL relative to the api base
    filename: z.string(),
    contentType: z.string(),
    size: z.number().int().nonnegative(),
    kind: FeedbackAttachmentKindSchema,
});
/** What the client includes in the submit payload — just the IDs. */
export const AttachmentRefSchema = z.object({
    id: z.string(),
});
// ── Submission payload ────────────────────────────────────────────────────
export const SubmitFeedbackSchema = z.object({
    type: FeedbackTypeSchema,
    app: FeedbackAppSchema,
    context: z.string().max(255).optional(),
    subject: z.string().max(120).optional(),
    message: z.string().min(1).max(4000),
    metadata: z.record(z.unknown()).optional(),
    attachments: z.array(AttachmentRefSchema).max(3).optional(),
});
// ── UI helpers ────────────────────────────────────────────────────────────
export const FEEDBACK_TYPE_LABELS = {
    bug: 'Bug',
    feature_request: 'Feature request',
    general: 'General feedback',
    complaint: 'Complaint',
};
export const FEEDBACK_STATUS_LABELS = {
    new: 'New',
    reviewed: 'Reviewed',
    in_progress: 'In progress',
    resolved: 'Resolved',
    closed: 'Closed',
    wont_fix: "Won't fix",
};
export const MAX_ATTACHMENTS = 3;
export const MAX_ATTACHMENT_BYTES = 5 * 1024 * 1024;
export const ALLOWED_ATTACHMENT_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
//# sourceMappingURL=types.js.map